import React from 'react';
import './ArticleSourcesList.scss';

interface ArticleSourcesListProps {
    field_header?: string;
    field_sources?: {
        value: string;
    }[];
}

export const ArticleSourcesList = ({
    sources,
}: {
    sources?: ArticleSourcesListProps;
}) => {
    const sourceTitle = sources?.field_header;
    const sourceCitations = sources?.field_sources;

    return (
        <div className="article-sources">
            <h3>{sourceTitle}</h3>
            <ol>
                {sourceCitations.map((cite, index) => (
                    <li
                        key={cite.value + index}
                        id={`article-source-${index + 1}`}
                    >
                        <div>
                            <span>{index + 1}.</span>
                            <span>{cite.value}</span>
                        </div>
                    </li>
                ))}
            </ol>
        </div>
    );
};
